import hash from "object-hash";

export const cached = {};

export const cache = {

    async all(){
        return cached;
    },

    async remember(key, value){
        const result = typeof value === 'function' ? await value() : value;
        cached[ hash(key) ] = result;
        return result;
    },

    async get(key, default_value = null){
        const hashed = hash(key);
        if( typeof cached[hashed] !== 'undefined' ) return cached[ hashed ];
        return default_value;
    },

    async has(key){
        return typeof cached[ hash(key) ] !== 'undefined';
    },

    async forget(key){
        if( typeof cached[ hash(key) ] !== 'undefined' ){
            cached[ hash(key) ] = undefined;
            delete cached[ hash(key) ];
        }
    },

};

export default cache;
